module.exports = __webpack_public_path__ + "img/lock_animated.efdefeee.svg";